import { render, staticRenderFns } from "./group-icon.vue?vue&type=template&id=98020680&scoped=true"
import script from "./group-icon.vue?vue&type=script&lang=js"
export * from "./group-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98020680",
  null
  
)

export default component.exports